// Classes Tailwind sempre completas (não interpoladas) para o purge do Tailwind detectar em build.
export const STATUS_CONFIG = {
    ABERTA: { label: "Aberta", className: "bg-primary/10 text-primary" },
    EM_ANDAMENTO: { label: "Em andamento", className: "bg-amber-100 text-amber-700" },
    FINALIZADA: { label: "Finalizada", className: "bg-success/10 text-success" },
    CANCELADA: { label: "Cancelada", className: "bg-destructive/10 text-destructive" },
    ELIMINADA: { label: "Eliminada", className: "bg-muted text-foreground/70" },
};

export function statusInfo(status) {
    return STATUS_CONFIG[status] || { label: status || "-", className: "bg-muted text-muted-foreground" };
}

export const PRIORIDADE_CONFIG = {
    BAIXA: { label: "Baixa", className: "bg-muted text-muted-foreground" },
    NORMAL: { label: "Normal", className: "bg-primary/10 text-primary" },
    ALTA: { label: "Alta", className: "bg-amber-100 text-amber-700" },
    URGENTE: { label: "Urgente", className: "bg-destructive/10 text-destructive" },
};

export function prioridadeInfo(prioridade) {
    if (!prioridade) return null;
    return PRIORIDADE_CONFIG[prioridade] || { label: prioridade, className: "bg-muted text-muted-foreground" };
}

// Apresentação (cor/ícone/texto) das ações — a EXISTÊNCIA do botão sempre vem de acoesDisponiveis (backend).
export const ACAO_CONFIG = {
    ENVIAR: { label: "Enviar", variant: "blue", iconLeft: "fa fa-paper-plane" },
    CONFIRMAR: { label: "Confirmar", variant: "blue", iconLeft: "fa fa-check" },
    REPROVAR: { label: "Reprovar", variant: "red", iconLeft: "fa fa-times-circle" },
    RECUSAR: { label: "Recusar", variant: "red", iconLeft: "fa fa-times-circle" },
    APROVAR: { label: "Aprovar", variant: "green", iconLeft: "fa fa-check-circle" },
    APROVAR_PARCIAL: { label: "Aprovar Parcial", variant: "yellow", iconLeft: "fa fa-check-double" },
    RETIFICAR: { label: "Retificar", variant: "yellow", iconLeft: "fa fa-undo" },
    LANCADO: { label: "Lançado", variant: "green", iconLeft: "fa fa-check" },
    CONCLUIR: { label: "Concluir", variant: "green", iconLeft: "fa fa-flag-checkered" },
    CANCELAR: { label: "Cancelar", variant: "red", iconLeft: "fa fa-ban" },
    RETORNAR: { label: "Retornar", variant: "yellow", iconLeft: "fa fa-arrow-left" },
    REGISTRAR: { label: "Registrar", variant: "green", iconLeft: "fa fa-money-check" },
    REGULARIZAR: { label: "Regularizar", variant: "blue", iconLeft: "fa fa-file-signature" },
};

export function acaoInfo(acao) {
    return ACAO_CONFIG[acao] || { label: acao, variant: "gray", iconLeft: "fa fa-play" };
}

// Fallback para etapas fora do processoRegistry: "ETAPA_2_APROVACAO_SOLICITACAO" -> "Aprovação Solicitação"
export function humanizarEtapa(etapaCodigo) {
    if (!etapaCodigo) return "-";
    return etapaCodigo
        .replace(/^ETAPA_\d+_/, "")
        .split("_")
        .map(p => p.charAt(0) + p.slice(1).toLowerCase())
        .join(" ");
}

// "MOTIVO_EXEMPLO" -> "Motivo exemplo" — usado para exibir enums de formulário (tipo de despesa,
// motivo de desligamento etc.) sem precisar de um dicionário de labels dedicado por processo.
export function humanizarEnum(valor) {
    if (!valor) return null;
    return valor.split("_").map(p => p.charAt(0) + p.slice(1).toLowerCase()).join(" ");
}
